export default __webpack_public_path__ + "static/media/hmhero.8d468f27.jpg";